export const addStudentDg = `
<div class="screen-overlay studentdg-overlay">
	<div class="studentdg dialog">
		<div class="dialog-header">Add Name</div>
		<div class="dialog-fields-section">
			<div class="studentdg-fieldInstructionsDiv">
				Enter a unique name for yourself.
			</div>
			<div class="dialog-textfield">
				<input class="studentdg-nameInput" type="text"
					placeholder="Username" maxlength="30"/>
			</div>
			<div class="dialog-horizontalRadioBtnGroup sdg-codeQuestionDiv">
				Do you have a team code?
				<label>
					<input type="radio" name="codeQuestion" value="yes"/>Yes
				</label>
				<label>
					<input type="radio" name="codeQuestion" value="no"/>No
				</label>
			</div>
			<div class="dialog-textfield">
				<input class="studentdg-codeInput" type="text"
					placeholder="Team Code" maxlength="15"/>
			</div>
		</div>
		<div class="studentdg-info">
		</div>
		<div class="studentdg-buttons">
			<div class="m-bigBtnDiv">
				<button class="studentdg-saveBtn">Save</button>
			</div>
			<div class="m-bigBtnDiv">
				<button class="studentdg-cancelBtn">Cancel</button>
			</div>
		</div>
	</div>
</div>
`;